"use client";
import { IAccountAssets, IUserData } from "@/types";
import { FilePanelProps, useBlockNoteEditor } from "@blocknote/react";
import AssetsV2 from "../assets/index-v2";

export function DorasFilePanel({
    props,
    assets,
    setAssets,
    account_id,
    brand_id,
    account,
}: {
    props: FilePanelProps;
    assets: IAccountAssets[] | undefined;
    setAssets?: (assets: IAccountAssets[]) => void;
    account_id?: string;
    brand_id?: any;
    account?: IUserData;
}) {
    const { block } = props;
    const { url }: any = block.props;
    const editor = useBlockNoteEditor();
    return (
        <AssetsV2
            _className="flex max-h-96 h-full flex-col gap-2 !overflow-y-scroll rounded-md bg-popover p-2 w-[30rem] text-foreground"
            popover={true}
            assets={assets || []}
            block={{
                url: url,
            }}
            update={(asset) => {
                const updateData = {
                    props: {
                        name: asset.title,
                        alt: asset.title,
                        url: asset.url,
                    },
                };
                editor.updateBlock(block, updateData);
            }}
            setAssets={(data) => setAssets?.(data)}
            account={account}
        />
    );
}
